import React from "react";
import styled from "styled-components";
import {TypeOfItem, TypeOfItemsAngles, TypeOfItemsMiniAngles} from "../../types";

const ContainerLeftTop = styled.div.withConfig({
    shouldForwardProp: (prop) => prop !== 'isDrag',
})<{size: number; isDrag?: boolean}>`
    position: relative;
    width: ${({size}) => size}px;
    height: ${({size}) => size}px;
`;

const ContainerRightTop = styled(ContainerLeftTop).withConfig({
    shouldForwardProp: (prop) => prop !== 'isDrag',
})<{size: number; isDrag?: boolean}>``;

const ContainerRightBottom = styled(ContainerLeftTop).withConfig({
    shouldForwardProp: (prop) => prop !== 'isDrag',
})<{isDrag?: boolean; size: number}>`
    transform: ${({isDrag, size}) => `translate(${isDrag ? size * -1 : 0}px, ${isDrag ? -size : 0}px)`};
`;

const ContainerLeftBottom = styled(ContainerLeftTop).withConfig({
    shouldForwardProp: (prop) => prop !== 'isDrag',
})``;

const BigContainerLeftTop = styled.div.withConfig({
    shouldForwardProp: (prop) => prop !== 'isDrag',
})<{size: number; isDrag?: boolean}>`
    position: relative;
    width: ${({size}) => size}px;
    height: ${({size}) => size}px;
`;

// transform в этих блоках необходим для правильного позиционирования элементов на поле
const BigContainerLeftBottom = styled.div.withConfig({
    shouldForwardProp: (prop) => prop !== 'isDrag',
})<{size: number; isDrag?: boolean}>`
    position: relative;
    width: ${({size}) => size}px;
    height: ${({size}) => size}px;
    transform: ${({isDrag, size}) => `translate(${isDrag ? -size * -1 : 0}px, ${isDrag ? -size : 0}px)`};
`;

const BigContainerRightBottom = styled.div.withConfig({
    shouldForwardProp: (prop) => prop !== 'isDrag',
})<{size: number; isDrag?: boolean}>`
    position: relative;
    width: ${({size}) => size}px;
    height: ${({size}) => size}px;
    transform: ${({isDrag, size}) => `translate(${isDrag ? size * -1 : 0}px, ${isDrag ? -size : 0}px)`};
`;

const AbsoluteRow = styled.div<{top: number}>`
    position: absolute;
    top: ${({top}) => top}px;
`;

const AbsoluteCell = styled.div<{right: number}>`
    position: absolute;
    right: ${({right}) => right}px;
`;

const BigContainerRightTop = styled.div.withConfig({
    shouldForwardProp: (prop) => prop !== 'isDrag',
})<{size: number; isDrag?: boolean}>`
    position: relative;
    width: ${({size}) => size}px;
    height: ${({size}) => size}px;
`;

interface Props {
    size: number;
    count: number;
    component: ({size, typeOfItem}: { size: number; typeOfItem: TypeOfItem }) => JSX.Element;
    type: TypeOfItemsMiniAngles | TypeOfItemsAngles;
    isDrag?: boolean;
}

export const BaseItemAngle = ({size, count, component: Component, type, isDrag}: Props) => {
    switch (type) {
        case "MINI_ANGLE_LEFT_TOP":
            return (
                <ContainerLeftTop isDrag={isDrag} size={size}>
                    <AbsoluteRow top={0}>
                        <AbsoluteCell right={size * -2}>
                            <Component typeOfItem={type} size={size} />
                        </AbsoluteCell>
                        <AbsoluteCell right={size * -1}>
                            <Component typeOfItem={type} size={size} />
                        </AbsoluteCell>
                    </AbsoluteRow>
                    <AbsoluteRow top={size}>
                        <AbsoluteCell right={size * -1}>
                            <Component typeOfItem={type} size={size} />
                        </AbsoluteCell>
                    </AbsoluteRow>
                </ContainerLeftTop>
            );
        case "MINI_ANGLE_RIGHT_TOP":
            return (
                <ContainerRightTop isDrag={isDrag} size={size}>
                    <AbsoluteRow top={0}>
                        <AbsoluteCell right={size * -2}>
                            <Component typeOfItem={type} size={size} />
                        </AbsoluteCell>
                        <AbsoluteCell right={size * -1}>
                            <Component typeOfItem={type} size={size} />
                        </AbsoluteCell>
                    </AbsoluteRow>
                    <AbsoluteRow top={size}>
                        <AbsoluteCell right={size * -2}>
                            <Component typeOfItem={type} size={size} />
                        </AbsoluteCell>
                    </AbsoluteRow>
                </ContainerRightTop>
            );
        case "MINI_ANGLE_RIGHT_BOTTOM":
            return (
                <ContainerRightBottom isDrag={isDrag} size={size}>
                    <AbsoluteRow top={0}>
                        <AbsoluteCell right={size * -2}>
                            <Component typeOfItem={type} size={size} />
                        </AbsoluteCell>
                    </AbsoluteRow>
                    <AbsoluteRow top={size}>
                        <AbsoluteCell right={size * -2}>
                            <Component typeOfItem={type} size={size} />
                        </AbsoluteCell>
                        <AbsoluteCell right={size * -1}>
                            <Component typeOfItem={type} size={size} />
                        </AbsoluteCell>
                    </AbsoluteRow>
                </ContainerRightBottom>
            );
        case "MINI_ANGLE_LEFT_BOTTOM":
            return (
                <ContainerLeftBottom isDrag={isDrag} size={size}>
                    <AbsoluteRow top={0}>
                        <AbsoluteCell right={size * -1}>
                            <Component typeOfItem={type} size={size} />
                        </AbsoluteCell>
                    </AbsoluteRow>
                    <AbsoluteRow top={size}>
                        <AbsoluteCell right={size * -2}>
                            <Component typeOfItem={type} size={size} />
                        </AbsoluteCell>
                        <AbsoluteCell right={size * -1}>
                            <Component typeOfItem={type} size={size} />
                        </AbsoluteCell>
                    </AbsoluteRow>
                </ContainerLeftBottom>
            );

        case "ANGLE_LEFT_TOP":
            return (
                <BigContainerLeftTop isDrag={isDrag} size={size}>
                    <AbsoluteRow top={size * 0}>
                        <AbsoluteCell right={size * -2}>
                            <Component typeOfItem={type} size={size} />
                        </AbsoluteCell>
                        <AbsoluteCell right={size * -1}>
                            <Component typeOfItem={type} size={size} />
                        </AbsoluteCell>
                        <AbsoluteCell right={size * 0}>
                            <Component typeOfItem={type} size={size} />
                        </AbsoluteCell>
                    </AbsoluteRow>
                    <AbsoluteRow top={size * 1}>
                        <AbsoluteCell right={size * 0}>
                            <Component typeOfItem={type} size={size} />
                        </AbsoluteCell>
                    </AbsoluteRow>
                    <AbsoluteRow top={size * 2}>
                        <AbsoluteCell right={size * 0}>
                            <Component typeOfItem={type} size={size} />
                        </AbsoluteCell>
                    </AbsoluteRow>
                </BigContainerLeftTop>
            );
        case "ANGLE_LEFT_BOTTOM":
            return (
                <BigContainerLeftBottom isDrag={isDrag} size={size}>
                    <AbsoluteRow top={size * 0}>
                        <AbsoluteCell right={size * 0}>
                            <Component typeOfItem={type} size={size} />
                        </AbsoluteCell>
                    </AbsoluteRow>
                    <AbsoluteRow top={size * 1}>
                        <AbsoluteCell right={size * 0}>
                            <Component typeOfItem={type} size={size} />
                        </AbsoluteCell>
                    </AbsoluteRow>
                    <AbsoluteRow top={size * 2}>
                        <AbsoluteCell right={size * -2}>
                            <Component typeOfItem={type} size={size} />
                        </AbsoluteCell>
                        <AbsoluteCell right={size * -1}>
                            <Component typeOfItem={type} size={size} />
                        </AbsoluteCell>
                        <AbsoluteCell right={size * 0}>
                            <Component typeOfItem={type} size={size} />
                        </AbsoluteCell>
                    </AbsoluteRow>
                </BigContainerLeftBottom>
            );
        case "ANGLE_RIGHT_BOTTOM":
            return (
                <BigContainerRightBottom isDrag={isDrag} size={size}>
                    <AbsoluteRow top={size * 0}>
                        <AbsoluteCell right={size * -2}>
                            <Component typeOfItem={type} size={size} />
                        </AbsoluteCell>
                    </AbsoluteRow>
                    <AbsoluteRow top={size * 1}>
                        <AbsoluteCell right={size * -2}>
                            <Component typeOfItem={type} size={size} />
                        </AbsoluteCell>
                    </AbsoluteRow>
                    <AbsoluteRow top={size * 2}>
                        <AbsoluteCell right={size * -2}>
                            <Component typeOfItem={type} size={size} />
                        </AbsoluteCell>
                        <AbsoluteCell right={size * -1}>
                            <Component typeOfItem={type} size={size} />
                        </AbsoluteCell>
                        <AbsoluteCell right={size * 0}>
                            <Component typeOfItem={type} size={size} />
                        </AbsoluteCell>
                    </AbsoluteRow>
                </BigContainerRightBottom>
            );
        case "ANGLE_RIGHT_TOP":
            return (
                <BigContainerRightTop isDrag={isDrag} size={size}>
                    <AbsoluteRow top={size * 0}>
                        <AbsoluteCell right={size * -2}>
                            <Component typeOfItem={type} size={size} />
                        </AbsoluteCell>
                        <AbsoluteCell right={size * -1}>
                            <Component typeOfItem={type} size={size} />
                        </AbsoluteCell>
                        <AbsoluteCell right={size * 0}>
                            <Component typeOfItem={type} size={size} />
                        </AbsoluteCell>
                    </AbsoluteRow>
                    <AbsoluteRow top={size * 1}>
                        <AbsoluteCell right={size * -2}>
                            <Component typeOfItem={type} size={size} />
                        </AbsoluteCell>
                    </AbsoluteRow>
                    <AbsoluteRow top={size * 2}>
                        <AbsoluteCell right={size * -2}>
                            <Component typeOfItem={type} size={size} />
                        </AbsoluteCell>
                    </AbsoluteRow>
                </BigContainerRightTop>
            );
        default:
            return null;
    }
}
